import requestService from '@/services/requester'

const RESOURCE_NAME = '/calibers'
const API_URL = requestService.API_BASE_URL + RESOURCE_NAME

let calibersService = {
    async retrieve(parameters) {
        let endpoint = `${API_URL}`
        return requestService.retrieve(endpoint, parameters)
    },

    async update (data) {
        let endpoint = `${API_URL}/`
        return requestService.update(endpoint, data)
    },

    async delete (parameters) {
        let endpoint = `${API_URL}/delete`
        return requestService.delete(endpoint, parameters)
    },

    async restore (parameters) {
        let endpoint = `${API_URL}/restore/`
        return requestService.update(endpoint, parameters)
    },

    async create (parameters) {
        let endpoint = `${API_URL}/create`
        return requestService.create(endpoint, parameters)
    }
}

export default calibersService
